var React = require('react');

function CloudHail (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 352a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm-192 96a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm128 0a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm-64-96a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM64 448a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm64-96a32 32 0 1 0 32 32 32 32 0 0 0-32-32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512 224a96 96 0 0 1-96 96H96a96 96 0 0 1-96-96c0-42.5 27.8-78.2 66.1-90.8A113.72 113.72 0 0 1 64 112 111.94 111.94 0 0 1 176 0c43.3 0 80.4 24.8 99 60.8C289.7 43.3 311.4 32 336 32a80 80 0 0 1 80 80 78.09 78.09 0 0 1-1.6 16.2c.5 0 1-.2 1.6-.2a96 96 0 0 1 96 96z","className":"fa-primary","key":2})]);
}

CloudHail.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = CloudHail;

CloudHail.default = CloudHail;
